// Login
import LoginSCIcon from '~/assets/images/login/secondary.svg';

// Mode
import ModeModalCIcon from '~/assets/images/modal/trash.svg';

// Profile Dropdown Icons
import APIKeysCIcon from '~/assets/images/sidebar/api-keys-new.jsx';
import WebhooksCIcon from '~/assets/images/sidebar/webhook-new.jsx';
import WebhooksSVGIcon from '~/assets/images/sidebar/webhook-svg.svg';

// Select Arrow
import MultiSelectArrowCIcon from '~/assets/images/select-icons/select-arrow.svg';
import MultiSelectCrossCIcon from '~/assets/images/select-icons/select-cross.svg';

// Snackbar
import SuccessCIcon from '~/assets/images/snackbar/success.svg';
import ErrorCIcon from '~/assets/images/snackbar/error.svg';
import AlertCIcon from '~/assets/images/snackbar/notification.svg';
import RemoveNotificationCIcon from '~/assets/images/snackbar/remove.svg';

// Accounts
import AccountExportCIcon from '~/assets/images/accounts/export.jsx';
import BtnDownloadIcon from '~/assets/images/accounts/btnDownloadIcon.svg';
import NoRecordsDownloadIcon from '~/assets/images/accounts/noRecordsDownloadIcon.svg';

// Billing Plan
import PaymentMethodIcon from '~/assets/images/billingPlan/paymentMethodIcon.svg';
import WalletIcon from '~/assets/images/billingPlan/walletIcon.svg';
import PaymentMethodAddIcon from '~/assets/images/billingPlan/addIcon.svg';
import NoTransactionsIcon from '~/assets/images/billingPlan/cardNoRecords.svg';
import ExportPaymentIcon from '~/assets/images/billingPlan/exportIcon.svg';
import AddPaymentMethod from '~/assets/images/billingPlan/addPaymentMethod.svg';
import ExportModalIcon from '~/assets/images/billingPlan/exportModalIcon.svg';

// New Sidebar
import UserCircleCIcon from '~/assets/images/new-sidebar/user-circle.jsx';
import CompanyCIcon from '~/assets/images/new-sidebar/company.jsx';
import SubCompanyCIcon from '~/assets/images/new-sidebar/sub-company.jsx';
import MultipleUsersCIcon from '~/assets/images/new-sidebar/multiple-users.jsx';
import CustomField2CIcon from '~/assets/images/new-sidebar/custom-field.jsx';
import Tags2CIcon from '~/assets/images/new-sidebar/tags.jsx';
import ImportExportCIcon from '~/assets/images/new-sidebar/import-export.jsx';
import CallCIcon from '~/assets/images/new-sidebar/call.jsx';
import QRCodeCIcon from '~/assets/images/new-sidebar/QR-code.jsx';
import MailboxCIcon from '~/assets/images/new-sidebar/mailbox.jsx';
import Wallet2CIcon from '~/assets/images/new-sidebar/wallet.jsx';
import SubscriptionCIcon from '~/assets/images/new-sidebar/subscription.jsx';

// Admin
import AdminPanelCIcon from '~/assets/images/admin/adminpanel.svg';
import DiableCIcon from '~/assets/images/admin/disable.svg';
import FundsCIcon from '~/assets/images/admin/funds.svg';
import GraphCIcon from '~/assets/images/admin/graph.svg';
import AdminLogoutCIcon from '~/assets/images/admin/logout.svg';
import OrderCIcon from '~/assets/images/admin/orders.svg';
import RefreshCIcon from '~/assets/images/admin/refresh.svg';
import RevenueCIcon from '~/assets/images/admin/revenue.svg';
import SearchCIcon from '~/assets/images/admin/search.png';
import UserCIcon from '~/assets/images/admin/user.svg';
import User2CIcon from '~/assets/images/admin/usericon.svg';
import WebCIcon from '~/assets/images/admin/web.svg';
import CSVIcon from '~/assets/images/admin/csv-download.svg';
import PDFIcon from '~/assets/images/admin/pdf-download.svg';
import TransactionCIcon from '~/assets/images/admin/view-transaction.svg';
import RemoveFundsCIcon from '~/assets/images/admin/remove-funds.svg';
import AddFundsCIcon from '~/assets/images/admin/add-funds.svg';
import DetailsCIcon from '~/assets/images/admin/eye.svg';

// Hire Designer
import Step1CIcon from '~/assets/images/hire-designer/submit.svg';
import Step2CIcon from '~/assets/images/hire-designer/pen.svg';
import ArrowHireCIcon from '~/assets/images/hire-designer/arrow-hire.svg';
import ConfirmPurchaseCIcon from '~/assets/images/hire-designer/trash.svg';
import RequestChangesCIcon from '~/assets/images/hire-designer/request.svg';
import MarkAsCompletedCIcon from '~/assets/images/hire-designer/tick.svg';
import FileUploadCIcon from '~/assets/images/hire-designer/upload.svg';

// Campaigns
import NoCampaignsCIcon from '~/assets/images/campaigns/no-campaigns.svg';
import ZoomInCIcon from '~/assets/images/campaigns/plus.svg';
import ZoomOutCIcon from '~/assets/images/campaigns/minus.svg';
import ResetZoomCIcon from '~/assets/images/campaigns/zoom.svg';
import EnvelopeCIcon from '~/assets/images/campaigns/envelope.svg';
import ClockCircleCIcon from '~/assets/images/campaigns/clock-circle.svg';
import DetailsErrorCIcon from '~/assets/images/campaigns/warning-error.svg';
import LeaveCampaignNew from '~/assets/images/campaigns/leaveCampaignNew.svg';
import CampaignDuplicate from '~/assets/images/campaigns/campaginDuplicate.svg';
import DraftRecovery from '~/assets/images/campaigns/draftRecovery.svg';
import CampaignCrossModal from '~/assets/images/campaigns/campaignCrossModal.svg';
import PlusStep from '~/assets/images/campaigns/plusStep.svg';

// Contact-details
import ArrowDownCIcon from '~/assets/images/contact-details/arrow-down.svg';
import DetailsExportCIcon from '~/assets/images/contact-details/details-export.svg';
import ExportNoteCIcon from '~/assets/images/contact-details/export-new.svg';
import DeleteNoteCIcon from '~/assets/images/contact-details/trash-new.jsx';
import VerifiedCIcon from '~/assets/images/contact-details/verified.svg';
import NotVerifiedCIcon from '~/assets/images/contact-details/not-verified.svg';
import VerifiiedIcon2 from '~/assets/images/contact-details/check-circle.svg';
import NotVerifiedCIcon2 from '~/assets/images/contact-details/remove-circle.svg';
import TrashNoteCIcon from '~/assets/images/contact-details/trash-note.jsx';
import Tick from '~/assets/images/contact-details/tick.jsx';
import DetailsCrossCIcon from '~/assets/images/contact-details/cross.svg';
import DialogCloseCIcon from '~/assets/images/contact-details/dialog-close.svg';
import EditNoteNewCIcon from '~/assets/images/contact-details/edit-note.jsx';
import AddNoteCIcon from '~/assets/images/contact-details/add-note.jsx';
import ContactInfoCIcon from '~/assets/images/contact-details/exclamation-circle.svg';
import PropertyLockCIcon from '~/assets/images/contact-details/property-lock.svg';
import NoCustomFieldsCIcon from '~/assets/images/contact-details/no-custom-field.svg';
import CheckedCIcon from '~/assets/images/contact-details/checked.svg';
import UncheckedCIcon from '~/assets/images/contact-details/unchecked.svg';
import RemovedCheckedCIcon from '~/assets/images/contact-details/remove-checked.svg';
import BulkActionsCIcon from '~/assets/images/contact-details/table-arrow.svg';
import UserImportIcon from '~/assets/images/contacts/userImport.svg';
import CustomFieldImportIcon from '~/assets/images/contacts/customFields.svg';
import HomeImportIcon from '~/assets/images/contacts/home.svg';
import WarningErrorImport from '~/assets/images/contacts/warning-error.svg';
import ImportConfirmModalCIcon from '~/assets/images/contacts/warning-error-orange.svg';

// Engagement
import NoEngagmentCIcon from '~/assets/images/engagement/Frame.svg';
import ModalArchive from '~/assets/images/qr-codes/modalArchive.svg';
import ModalRestore from '~/assets/images/qr-codes/modalRestore.svg';
import QRArrowSmallLeft from '~/assets/images/qr-codes/arrowSmallLeft.svg';
import NoQRCode from '~/assets/images/qr-codes/no-round-qr-code.svg';

// Create Order New
import MailContactsCIcon from '~/assets/images/create-order/my-contacts.svg';
import UploadListCIcon from '~/assets/images/create-order/upload.svg';
import FindNewCIcon from '~/assets/images/create-order/new-contacts.svg';
import SearchByNameAddressCIcon from '~/assets/images/create-order/search.svg';
import SearchByImportCIcon from '~/assets/images/create-order/import.svg';
import SearchByTagsCIcon from '~/assets/images/create-order/tag.svg';
import PreviewPartCIcon from '~/assets/images/create-order/preview.png';
import BackArrowCIcon from '~/assets/images/create-order/back-arrow.svg';
import MailerProofReviewCIcon from '~/assets/images/create-orders/download.svg';

// Phone Tracking
import NoTrackingCIcon from '~/assets/images/phone-tracking/no-tracking.svg';
import SelectArrowCIcon from '~/assets/images/phone-tracking/down.svg';
import ArrowBackCIcon from '~/assets/images/phone-tracking/arrow-left.svg';

// Contacts
import ActionsCIcon from '~/assets/images/contacts/actions.svg';
import AddDarkCIcon from '~/assets/images/contacts/add-dark.svg';
import AddCIcon from '~/assets/images/contacts/add.svg';
import ArrowDownContactsCIcon from '~/assets/images/contacts/arrow-down.svg';
import ContactSearchCIcon from '~/assets/images/contacts/contact-search.svg';
import CrossIconCIcon from '~/assets/images/contacts/cross-icon.svg';
import ExportCIcon from '~/assets/images/contacts/export.svg';
import FileAddCIcon from '~/assets/images/contacts/file-add.svg';
import ActiveFilterCIcon from '~/assets/images/contacts/filter-2.svg';
import InActiveFilterCIcon from '~/assets/images/contacts/filter.svg';
import FilterActiveCIcon from '~/assets/images/contacts/filter-hovered.jsx';
import ImportLightCIcon from '~/assets/images/contacts/import-light.svg';
import ImportCIcon from '~/assets/images/contacts/import.svg';
import ImportModal from '~/assets/images/contacts/import-modal.svg';
import NoContactCIcon from '~/assets/images/contacts/no-contact.svg';
import RemoveTagsCIcon from '~/assets/images/contacts/remove.svg';
import RemoveDncCIcon from '~/assets/images/contacts/remove-option.svg';
import Add2CIcon from '~/assets/images/contacts/plus.svg';
import Remove2CIcon from '~/assets/images/contacts/minus.svg';
import Export2CIcon from '~/assets/images/contacts/upload.svg';
import ExportContacts2CIcon from '~/assets/images/contacts/download.svg';
import Add3CIcon from '~/assets/images/contacts/create.svg';
import contactInfo2CIcon from '~/assets/images/contacts/user.svg';
import tooltipCIcon from '~/assets/images/contacts/exclamation-circle.svg';
import mailingInfoCIcon from '~/assets/images/contacts/mailing.svg';
import propertyInfoCIcon from '~/assets/images/contacts/property.svg';
import NoContact2CIcon from '~/assets/images/contacts/contact-blank.svg';
import FilterCrossCIcon from '~/assets/images/contacts/filters-cross.svg';
import ImportContactsCIcon from '~/assets/images/contacts/import-new.svg';
import FindNewContactsCIcon from '~/assets/images/contacts/find-new.svg';
import PlaceOrderCIcon from '~/assets/images/contacts/place-order.svg';
import ExportModalNewCIcon from '~/assets/images/contacts/export-new.svg';
import ArrowNew from '~/assets/images/contacts/arrow-new.jsx';
import DownloadFromTable from '~/assets/images/contacts/downloadTable.svg';
import DownloadFromTableHover from '~/assets/images/contacts/downloadTableHover.svg';

// Create-Orders
import ContactCIcon from '~/assets/images/create-orders/contacts.svg';
import HtmlIconCIcon from '~/assets/images/create-orders/html-icon.svg';
import ImageRectCIcon from '~/assets/images/create-orders/image-rect.svg';
import MailerCIcon from '~/assets/images/create-orders/mailer.svg';
import OrderCancelCIcon from '~/assets/images/create-orders/order-cancel.svg';
import OrderDetailsCIcon from '~/assets/images/create-orders/order-details.svg';
import OrderPostcardCIcon from '~/assets/images/create-orders/order-postcard.svg';
import OrderSubmitCIcon from '~/assets/images/create-orders/order-submit.svg';
import PlusIconCIcon from '~/assets/images/create-orders/plus-icon.svg';
import ReviewOrderCIcon from '~/assets/images/create-orders/review-order.svg';
import ScheduleOrderCIcon from '~/assets/images/create-orders/schedule-icon.svg';
import PreviewProofCIcon from '~/assets/images/create-orders/preview.svg';
import DownloadProofReviewCIcon from '~/assets/images/create-orders/download.svg';

// Order-Details
import OrderNumberCIcon from '~/assets/images/orders/order-number.svg';
import OrderNameCIcon from '~/assets/images/orders/order-name.svg';
import TemplateNameCIcon from '~/assets/images/orders/temp-name.svg';
import TemplateIdCIcon from '~/assets/images/orders/temp-id.svg';
import TotalCostCIcon from '~/assets/images/orders/coin-dollar.svg';
import RescheduleCIcon from '~/assets/images/order-details/reschedule.svg';
import PayAndProcessCIcon from '~/assets/images/order-details/pay-process.svg';
import CancelCIcon from '~/assets/images/order-details/remove.svg';
import MailerProofCIcon from '~/assets/images/order-details/download.svg';
import CancelOrderDetailsCIcon from '~/assets/images/order-details/cancel-order.svg';
import ProcessOrderNew from '~/assets/images/orders/processOrderNew.svg';

// Dashboard
import ArrowCIcon from '~/assets/images/dashboard/arrow.svg';
import DeliveredCIcon from '~/assets/images/dashboard/delievered.svg';
import EmailCIcon from '~/assets/images/dashboard/email-icon.svg';
import GraphDashboardCIcon from '~/assets/images/dashboard/graph.svg';
import InfoCIcon from '~/assets/images/dashboard/info-icon.svg';
import InfoCIconFill from '~/assets/images/dashboard/info-icon-fill.svg';
import ReturnPageCIcon from '~/assets/images/dashboard/return-page-icon.svg';

import ReturnedCIcon from '~/assets/images/dashboard/returned.svg';
import SentCIcon from '~/assets/images/dashboard/sent.svg';
import SpendingCIcon from '~/assets/images/dashboard/spending-icon.svg';
import TransitCIcon from '~/assets/images/dashboard/transit.svg';

// General
import WarningIcon from '~/assets/images/General/warning.svg';
import GeneralInviteCIcon from '~/assets/images/General/invite.svg';
import GeneralCrossCIcon from '~/assets/images/General/cross.svg';
import GeneralArchiveCIcon from '~/assets/images/General/archive.svg';
import GeneralRestoreCIcon from '~/assets/images/General/restore.svg';
import GeneralArrowBackCIcon from '~/assets/images/General/arrow-back.svg';
import GeneralLocationCIcon from '~/assets/images/General/location.svg';
import ArchiveConfirmCIcon from '~/assets/images/General/archiveConfirm.svg';
import CloseModalIcon from '~/assets/images/General/closeModalIcon.svg';
import CloseModalGrey from '~/assets/images/General/closeModalGrey.svg';
import ModeTickCIcon from '~/assets/images/General/mode-tick.jsx';
import senderAddress from '~/assets/images/General/senderAddress.svg';
import senderUser from '~/assets/images/General/user.svg';
import GeneralFormDropdownArrow from '~/assets/images/General/direction-down.svg';
import TableHamburgerIcon from '~/assets/images/General/tableHamburgerIcon.svg';
import MaterialEditOutlinedCIcon from '~/assets/images/General/edit-outline-material.svg';
import MaterialEditOutlinedLightCIcon from '~/assets/images/General/edit-outline-material-light.svg';
import MaterialArchiveOutlinedCIcon from '~/assets/images/General/archive-outline-material.svg';
import MaterialDeleteOutlinedCIcon from '~/assets/images/General/delete-outline-material.svg';
import MaterialDeleteOutlinedDangerCIcon from '~/assets/images/General/delete-outline-material-danger.svg';
import MaterialDeleteOutlinedModalCIcon from '~/assets/images/General/delete-outline-material-modal.svg';
import MaterialDownloadOutlinedCIcon from '~/assets/images/General/download-outline-material.svg';
import MaterialHistoryOutlinedCIcon from '~/assets/images/General/history-outline-material.svg';
import MaterialQrCodeOutlinedCIcon from '~/assets/images/General/qr-code-outline-material.svg';
import MaterialRestoreOutlinedCIcon from '~/assets/images/General/restore-outline-material.svg';
import MaterialRotateOutlinedCIcon from '~/assets/images/General/rotate-outline-material.svg';
import CheckSettingsIcon from '~/assets/images/settings/check.svg';
import XSettingsIcon from '~/assets/images/settings/x.svg';

// Header
import AccountCIcon from '~/assets/images/header/account.svg';
import ChatCIcon from '~/assets/images/header/chat.svg';
import DocumentationCIcon from '~/assets/images/header/documentation.svg';
import DropdownArrrowCIcon from '~/assets/images/header/dropdown-arrow.svg';
import HeaderDownArrowCIcon from '~/assets/images/header/header-down-arrow.svg';
import HelpCIcon from '~/assets/images/header/help.svg';
import HelpCenterCIcon from '~/assets/images/header/helpCenter.svg';
import Help2CIcon from '~/assets/images/header/help-icon.svg';
import IntegrationCIcon from '~/assets/images/header/integration.svg';
import OpenLetterConnectCIcon from '~/assets/images/header/open-letter-logo.svg';
import OpenLetterLogoCIcon from '~/assets/images/header/open-letter-logo.svg';
import SettingsCIcon from '~/assets/images/header/settings.svg';
import UserAvatarCIcon from '~/assets/images/header/user-avatar.svg';
import LogoutCIcon from '~/assets/images/header/logout.svg';
import DollarCIcon from '~/assets/images/header/dollar.svg';
import AdminPortalCIcon from '~/assets/images/header/admin-portal.svg';
import GeneralSettingsCIcon from '~/assets/images/header/general-settings.jsx';

// NewDropdown
import Settings2CIcon from '~/assets/images/new-profile-dropdown/settings.svg';
import UsersCIcon from '~/assets/images/new-profile-dropdown/user.svg';
import EngagementCIcon from '~/assets/images/new-profile-dropdown/engagement.svg';
import BillingCIcon from '~/assets/images/new-profile-dropdown/billing.svg';
import IntegrationsCIcon from '~/assets/images/new-profile-dropdown/integrations.svg';
import Logout2CIcon from '~/assets/images/new-profile-dropdown/logout.svg';
import DropdownArrowCIcon from '~/assets/images/user-table/dropdownArrow.svg';

// Integrations
import FramerCIcon from '~/assets/images/integrations/framer.svg';
import HubspotCIcon from '~/assets/images/integrations/hubspot.svg';
import LoomCIcon from '~/assets/images/integrations/loom.svg';
import SalesforceCIcon from '~/assets/images/integrations/salesforce.svg';
import SketchCIcon from '~/assets/images/integrations/sketch.svg';
import ZapierCIcon from '~/assets/images/integrations/zapier.svg';

// Login
import FrameCIcon from '~/assets/images/login/frame.svg';
import OpenLetterCIcon from '~/assets/images/login/open-letter.svg';
import SecondaryCIcon from '~/assets/images/login/secondary.svg';
import OnBoardCIcon from '~/assets/images/login/onboard-logo.svg';
import GoogleCIcon from '~/assets/images/login/google.svg';

// Modal
import CrossModalCIcon from '~/assets/images/modal/crossIcon.svg';
import ExportModalCIcon from '~/assets/images/modal/upload.jsx';
import ExportModalSVGCIcon from '~/assets/images/modal/export.svg';
import GreenTickCIcon from '~/assets/images/modal/green-tick.svg';
import GreenCrossCIcon from '~/assets/images/modal/green-cross.svg';
import ImportCancelCIcon from '~/assets/images/modal/import-cancel.svg';
import ImportSuccessCIcon from '~/assets/images/modal/import-success.svg';
import ModalCrossCIcon from '~/assets/images/modal/modal-cross.jsx';
import RedCrossCIcon from '~/assets/images/modal/red-cross.svg';
import VerifyLogoCIcon from '~/assets/images/modal/verifyLogo.svg';

// Orders
import AnalyticsNoDataCIcon from '~/assets/images/orders/analytics-nodata.jpg';
import AnalyticsCIcon from '~/assets/images/orders/analytics.svg';
import CalenderCIcon from '~/assets/images/orders/calendar.svg';
import CancelIconCIcon from '~/assets/images/orders/cancel-icon.svg';
import CancelOrderCIcon from '~/assets/images/orders/cancelOrder.svg';
import CancelOrderDisabledCIcon from '~/assets/images/orders/cancelOrderDisabled.svg';
import DeliverableCIcon from '~/assets/images/orders/deliverable.svg';
import DispatchCIcon from '~/assets/images/orders/dispatch.svg';
import InsufficientCIcon from '~/assets/images/orders/insufficient.svg';
import MailedCIcon from '~/assets/images/orders/delivery.svg';
import TransitOrderCIcon from '~/assets/images/orders/destination.svg';
import DeliveredOrderCIcon from '~/assets/images/orders/mail-plus.svg';
import SenderCIcon from '~/assets/images/orders/arrow-back.svg';
import RouteCIcon from '~/assets/images/orders/destination-second.svg';
import NoDataCIcon from '~/assets/images/orders/no-data.svg';
import NoScannedCIcon from '~/assets/images/orders/not-scanned.svg';
import PaymentCIcon from '~/assets/images/orders/payment-icon.svg';
import ProcessOrderCIcon from '~/assets/images/orders/processOrder.png';
import ProofCIcon from '~/assets/images/orders/proof-icon.svg';
import RemoveCIcon from '~/assets/images/orders/remove.svg';
import ScannedCIcon from '~/assets/images/orders/scanned-new.svg';
import TotalContactCIcon from '~/assets/images/orders/totalContact.svg';
import UndeliverableCIcon from '~/assets/images/orders/undeliverable.svg';
import CreateOrderCIcon from '~/assets/images/orders/create-order.svg';
import DownloadCIcon from '~/assets/images/orders/order-download.svg';
import DownloadProofCIcon from '~/assets/images/orders/mailer.svg';
import AdminOrderCancelCIcon from '~/assets/images/orders/order-cancel.svg';
import AdminOrderDispatchCIcon from '~/assets/images/orders/order-dispatch.svg';
import TotalContactsCIcon from '~/assets/images/orders/users.svg';
import DeliverableContactsCIcon from '~/assets/images/orders/delieverable-new.svg';
import UndelieverableContactsCIcon from '~/assets/images/orders/undelieverable.svg';
import TotalDNCCIcon from '~/assets/images/orders/DNC.svg';
import PayAndProcessNewCIcon from '~/assets/images/orders/pay-process.svg';
import ExportNewCIcon from '~/assets/images/orders/upload.svg';
import CancelOrderNewCIcon from '~/assets/images/orders/remove-new.svg';
import PlusCIcon from '~/assets/images/orders/plus.svg';
import ClearFilterCIcon from '~/assets/images/orders/clear-filter.svg';
import RescheduleActionCIcon from '~/assets/images/orders/reschedule.svg';
import PayAndProcessActionCIcon from '~/assets/images/orders/dollar.svg';
import DownloadProofActionCIcon from '~/assets/images/orders/download.svg';
import PayAndProcessModalCIcon from '~/assets/images/orders/pay-process-modal-icon.svg';
import CancelOrderModalCIcon from '~/assets/images/orders/cancel-modal-icon.svg';
import ModalOrderCrossCIcon from '~/assets/images/orders/modal-cross.svg';
import NoOrdersScreenCIcon from '~/assets/images/orders/no-orders.svg';
import SelectCloseCIcon from '~/assets/images/order-details/select-close-icon.svg';

// Plans
import CrossPlansCIcon from '~/assets/images/plans/cross-icon.svg';
import DowngradeCIcon from '~/assets/images/plans/downgrade-icon.svg';
import EnterpriseCIcon from '~/assets/images/plans/enterprise.svg';
import GrowthCIcon from '~/assets/images/plans/growth.svg';
import InfoPlansCIcon from '~/assets/images/plans/info-icon.svg';
import ModalClosePlansCIcon from '~/assets/images/plans/modal-close.svg';
import NextCIcon from '~/assets/images/plans/next.svg';
import PrevCIcon from '~/assets/images/plans/prev.svg';
import ProfessionalCIcon from '~/assets/images/plans/professional.svg';
import StaterCIcon from '~/assets/images/plans/starter.svg';
import UpgradeCIcon from '~/assets/images/plans/upgrade-icon.svg';

// Settings
import CopyCIcon from '~/assets/images/settings/copy.svg';
import DuplicateCIcon from '~/assets/images/settings/duplicate.svg';
import HideCIcon from '~/assets/images/settings/hide.svg';
import ShowCIcon from '~/assets/images/settings/show.svg';
import CustomFieldIcon from '~/assets/images/settings/file.svg';

// Sidebar
import ApiKeyCIcon from '~/assets/images/sidebar/api-keys.jsx';
import ApiLogsCIcon from '~/assets/images/sidebar/api-logs.jsx';
import ContactSideBarCIcon from '~/assets/images/sidebar/contact.jsx';
import ContactSideBarSvgCIcon from '~/assets/images/sidebar/contact.svg';
import CustomFieldsCIcon from '~/assets/images/sidebar/custom-fields.jsx';
import CustomFieldCIcon from '~/assets/images/sidebar/customField.jsx';
import GeneralCIcon from '~/assets/images/sidebar/general.jsx';
import OverviewCIcon from '~/assets/images/sidebar/overview.jsx';
import OverviewSvgCIcon from '~/assets/images/sidebar/overview.svg';
import PlanCIcon from '~/assets/images/sidebar/plan.jsx';
import ProfileCIcon from '~/assets/images/sidebar/profile.jsx';
import SidebarHoverCIcon from '~/assets/images/sidebar/sidebar-hover-arrow.svg';
import TagsCIcon from '~/assets/images/sidebar/tags.jsx';
import WalletCIcon from '~/assets/images/sidebar/wallet.jsx';
import WalletSvgCIcon from '~/assets/images/sidebar/wallet.svg';
import WebhookCIcon from '~/assets/images/sidebar/webhook.jsx';
import ContactImportCIcon from '~/assets/images/sidebar/import.jsx';
import ExportLogsCIcon from '~/assets/images/sidebar/exportIcon.jsx';

// Templates
import TemplateSearchCIcon from '~/assets/images/templates/template-search.svg';
import TemplateSearch2CIcon from '~/assets/images/templates/template-search-2.svg';
import TemplateCopyCIcon from '~/assets/images/templates/template-copy.svg';
import TemplateCrossCIcon from '~/assets/images/templates/cross.svg';
import TemplateAddCIcon from '~/assets/images/templates/add-icon.svg';
import TemplateFilterCIcon from '~/assets/images/templates/filter-2.svg';
import TemplateSearchOneCIcon from '~/assets/images/templates/search.svg';
import TemplatePostcardCIcon from '~/assets/images/templates/postcard.svg';
import TemplatePersonalizedCIcon from '~/assets/images/templates/personal-letter.svg';
import TemplateProfessionalCIcon from '~/assets/images/templates/professional-letter.svg';
import TemplateBiFoldCIcon from '~/assets/images/templates/bi-fold-self-mailers.svg';
import TemplateTrifoldCIcon from '~/assets/images/templates/tri-fold-self-mailers.svg';
import TemplateRealPennedCIcon from '~/assets/images/templates/real-penned-letters.svg';
import TemplateSnapPackCIcon from '~/assets/images/templates/snap-pack.svg';
import DuplicateTemplateCIcon from '~/assets/images/templates/duplicate.svg';
import DownloadTemplateCIcon from '~/assets/images/templates/download.svg';
import LeftArrowSlideCIcon from '~/assets/images/templates/left-arrow.svg';
import RightArrowSlideCIcon from '~/assets/images/templates/right-arrow.svg';
import NoTemplateCIcon from '~/assets/images/templates/no-template.svg';
import TemplateZoomCIcon from '~/assets/images/templates/template-zoom.svg';

// User Tables
import InviteCIcon from '~/assets/images/user-table/invite.svg';
import ResendCIcon from '~/assets/images/user-table/resend.svg';
import WarningCIcon from '~/assets/images/user-table/warning.svg';

// Wallets
import BalanceCIcon from '~/assets/images/wallet/balance.svg';
import BankCIcon from '~/assets/images/wallet/bank.svg';
import CreditCardFallbackCIcon from '~/assets/images/wallet/credit-card-fallback.svg';
import InfoWalletCIcon from '~/assets/images/wallet/info-icon.svg';
import MasterCardCIcon from '~/assets/images/wallet/mastercard.svg';
import PaymentWalletCIcon from '~/assets/images/wallet/payment-icon.svg';
import VisaCIcon from '~/assets/images/wallet/visa.svg';
import WalletPaymentCIcon from '~/assets/images/wallet/payment.svg';

// Webhook Details
import ForwardCIcon from '~/assets/images/webhook-details/forward-icon.svg';

// Webhooks
import ArrowRightCIcon from '~/assets/images/webhooks/arrow-right.svg';
import BackCIcon from '~/assets/images/webhooks/back.svg';
import CheckmarkCIcon from '~/assets/images/webhooks/checkmark.svg';
import CopyWebhookCIcon from '~/assets/images/webhooks/copy.svg';
import CopyIconCIcon from '~/assets/images/webhooks/copyIcon.svg';
import DisableCIcon from '~/assets/images/webhooks/disable.svg';
import DisabedCIcon from '~/assets/images/webhooks/disabled.svg';
import EyeCIcon from '~/assets/images/webhooks/eyeIcon.svg';
import HideWebhookCIcon from '~/assets/images/webhooks/hide.svg';
import InfoWebhookCIcon from '~/assets/images/webhooks/info.svg';
import ShowWebhookCIcon from '~/assets/images/webhooks/show.svg';

// Welcome Screen
import WelcomeCIcon from '~/assets/images/welcome-screen/welcome.svg';

import PropertyOffersBackround from '~/assets/images/property-offers/background.svg';

// Company
import CompanyArchiveBtnIcon from '~/assets/images/company/archiveBtn.svg';
import CopyIcon from '~/assets/images/company/copy.svg';
import CompanySearchIcon from '~/assets/images/company/search.svg';
import CompanyImageIcon from '~/assets/images/company/image.svg';
import CompanyUploadIcon from '~/assets/images/company/upload.svg';
import BrandingAssetsIcon from '~/assets/images/company/branding-asset.svg';
import SenderProfileIcon from '~/assets/images/company/senderProfileIcon.svg';

// Delete actions intentionally share one Material outlined glyph. These aliases
// preserve the existing public asset API while removing page-specific artwork.
const DeleteCIcon = MaterialDeleteOutlinedCIcon;
const PaymentMethodDelIcon = MaterialDeleteOutlinedDangerCIcon;
const DeleteCDCIcon = MaterialDeleteOutlinedModalCIcon;
const TrashCIcon = MaterialDeleteOutlinedCIcon;
const ContactDetailsDeleteCIcon = MaterialDeleteOutlinedModalCIcon;
const ReleasePhoneNumberCIcon = MaterialDeleteOutlinedModalCIcon;
const ReleasePhoneCIcon = MaterialDeleteOutlinedCIcon;
const DeleteContactsCIcon = MaterialDeleteOutlinedCIcon;
const Delete2CIcon = MaterialDeleteOutlinedCIcon;
const DeleteContacts2CIcon = MaterialDeleteOutlinedModalCIcon;
const TrashIcon = MaterialDeleteOutlinedModalCIcon;
const ModalTrashIcon = MaterialDeleteOutlinedModalCIcon;
const DeleteSettingCIcon = MaterialDeleteOutlinedCIcon;
const TemplateDeleteCIcon = MaterialDeleteOutlinedCIcon;
const TemplateTrashCIcon = MaterialDeleteOutlinedModalCIcon;
const TrashTemplateCIcon = MaterialDeleteOutlinedCIcon;
const DeleteUserCIcon = MaterialDeleteOutlinedCIcon;
const PaymentTrashCIcon = MaterialDeleteOutlinedCIcon;
const TrashWalletCIcon = MaterialDeleteOutlinedModalCIcon;
const DeleteWebhookCIcon = MaterialDeleteOutlinedCIcon;
const CompanyTrashIcon = MaterialDeleteOutlinedCIcon;

// Edit and rename actions intentionally share one Material outlined glyph.
// These aliases preserve the existing public asset API while removing
// page-specific pencil artwork.
const EditCIcon = MaterialEditOutlinedCIcon;
const Edit2CIcon = MaterialEditOutlinedCIcon;
const EditAccountsCIcon = MaterialEditOutlinedCIcon;
const Edit4CIcon = MaterialEditOutlinedCIcon;
const EditCampaignStepCIcon = MaterialEditOutlinedCIcon;
const CampaignPencil = MaterialEditOutlinedCIcon;
const EditCDCIcon = MaterialEditOutlinedCIcon;
const EditNoteCIcon = MaterialEditOutlinedCIcon;
const EditPhoneCIcon = MaterialEditOutlinedCIcon;
const EditCampaignCIcon = MaterialEditOutlinedCIcon;
const EditCampaignCIconBold = MaterialEditOutlinedCIcon;
const WhiteEditCIcon = MaterialEditOutlinedLightCIcon;
const GeneralPencilCIcon = MaterialEditOutlinedCIcon;
const GeneralEditIcon = MaterialEditOutlinedCIcon;
const EditSettingCIcon = MaterialEditOutlinedCIcon;
const EditUserCIcon = MaterialEditOutlinedCIcon;
const DetailsEditCIcon = MaterialEditOutlinedCIcon;
const EditWebhookCIcon = MaterialEditOutlinedCIcon;
const CompanyEditBtnIcon = MaterialEditOutlinedCIcon;

// Download actions use the same Material outlined family.
const CompanyDownloadIcon = MaterialDownloadOutlinedCIcon;

// History actions intentionally share one Material outlined glyph.
const HistoryCIcon = MaterialHistoryOutlinedCIcon;
const HistoryIcon = MaterialHistoryOutlinedCIcon;

// QR table actions use the same Material outlined family.
const QRCodeIcon = MaterialQrCodeOutlinedCIcon;
const ArchiveIcon = MaterialArchiveOutlinedCIcon;
const RestoreIcon = MaterialRestoreOutlinedCIcon;
const RotateCIcon = MaterialRotateOutlinedCIcon;

export {
  /* Login */
  LoginSCIcon,
  /* Mode */
  ModeModalCIcon,
  /* Profile Dropdown Icons */
  APIKeysCIcon,
  WebhooksCIcon,
  WebhooksSVGIcon,
  /* Select Arrow */
  MultiSelectArrowCIcon,
  MultiSelectCrossCIcon,
  /* Snackbar */
  SuccessCIcon,
  ErrorCIcon,
  AlertCIcon,
  RemoveNotificationCIcon,
  /* Accounts */
  DeleteCIcon,
  EditCIcon,
  Edit2CIcon,
  EditAccountsCIcon,
  Edit4CIcon,
  AccountExportCIcon,
  BtnDownloadIcon,
  NoRecordsDownloadIcon,
  // Billing Plan
  PaymentMethodIcon,
  WalletIcon,
  PaymentMethodAddIcon,
  PaymentMethodDelIcon,
  NoTransactionsIcon,
  ExportPaymentIcon,
  AddPaymentMethod,
  ExportModalIcon,
  /* New Sidebar */
  UserCircleCIcon,
  CompanyCIcon,
  SubCompanyCIcon,
  MultipleUsersCIcon,
  CustomField2CIcon,
  Tags2CIcon,
  ImportExportCIcon,
  CallCIcon,
  QRCodeCIcon,
  MailboxCIcon,
  Wallet2CIcon,
  SubscriptionCIcon,
  /* Admin */
  AdminPanelCIcon,
  DiableCIcon,
  FundsCIcon,
  GraphCIcon,
  AdminLogoutCIcon,
  OrderCIcon,
  RefreshCIcon,
  RevenueCIcon,
  SearchCIcon,
  UserCIcon,
  User2CIcon,
  WebCIcon,
  CSVIcon,
  PDFIcon,
  TransactionCIcon,
  RemoveFundsCIcon,
  AddFundsCIcon,
  DetailsCIcon,
  /* Hire Designer */
  Step1CIcon,
  Step2CIcon,
  ArrowHireCIcon,
  ConfirmPurchaseCIcon,
  RequestChangesCIcon,
  MarkAsCompletedCIcon,
  FileUploadCIcon,
  /* Campaigns */
  NoCampaignsCIcon,
  ZoomInCIcon,
  ZoomOutCIcon,
  ResetZoomCIcon,
  EnvelopeCIcon,
  ClockCircleCIcon,
  DetailsErrorCIcon,
  EditCampaignStepCIcon,
  CampaignPencil,
  LeaveCampaignNew,
  CampaignDuplicate,
  DraftRecovery,
  CampaignCrossModal,
  PlusStep,
  /* Contact-details */
  ArrowDownCIcon,
  DeleteCDCIcon,
  DetailsExportCIcon,
  EditCDCIcon,
  TrashCIcon,
  EditNoteCIcon,
  ExportNoteCIcon,
  DeleteNoteCIcon,
  VerifiedCIcon,
  VerifiiedIcon2,
  NotVerifiedCIcon,
  NotVerifiedCIcon2,
  TrashNoteCIcon,
  Tick,
  ContactDetailsDeleteCIcon,
  DetailsCrossCIcon,
  DialogCloseCIcon,
  EditNoteNewCIcon,
  AddNoteCIcon,
  ContactInfoCIcon,
  PropertyLockCIcon,
  NoCustomFieldsCIcon,
  CheckedCIcon,
  UncheckedCIcon,
  RemovedCheckedCIcon,
  BulkActionsCIcon,
  HomeImportIcon,
  UserImportIcon,
  CustomFieldImportIcon,
  WarningErrorImport,
  ImportConfirmModalCIcon,
  /* Engagement */
  NoEngagmentCIcon,
  QRCodeIcon,
  ArchiveIcon,
  HistoryIcon,
  RestoreIcon,
  ModalArchive,
  ModalRestore,
  QRArrowSmallLeft,
  NoQRCode,
  /* Create Order New */
  MailContactsCIcon,
  UploadListCIcon,
  FindNewCIcon,
  SearchByNameAddressCIcon,
  SearchByImportCIcon,
  SearchByTagsCIcon,
  PreviewPartCIcon,
  BackArrowCIcon,
  MailerProofReviewCIcon,
  /* Phone Tracking */
  HistoryCIcon,
  EditPhoneCIcon,
  ReleasePhoneCIcon,
  ReleasePhoneNumberCIcon,
  NoTrackingCIcon,
  SelectArrowCIcon,
  ArrowBackCIcon,
  /* Contacts */
  ActionsCIcon,
  AddDarkCIcon,
  AddCIcon,
  ArrowDownContactsCIcon,
  ContactSearchCIcon,
  CrossIconCIcon,
  DeleteContactsCIcon,
  ExportCIcon,
  FileAddCIcon,
  InActiveFilterCIcon,
  ActiveFilterCIcon,
  FilterActiveCIcon,
  ImportLightCIcon,
  ImportCIcon,
  ImportModal,
  NoContactCIcon,
  RemoveTagsCIcon,
  RemoveDncCIcon,
  Add2CIcon,
  Remove2CIcon,
  Delete2CIcon,
  Export2CIcon,
  DeleteContacts2CIcon,
  ExportContacts2CIcon,
  Add3CIcon,
  contactInfo2CIcon,
  tooltipCIcon,
  mailingInfoCIcon,
  propertyInfoCIcon,
  NoContact2CIcon,
  FilterCrossCIcon,
  ImportContactsCIcon,
  FindNewContactsCIcon,
  PlaceOrderCIcon,
  ExportModalNewCIcon,
  ArrowNew,
  DownloadFromTable,
  DownloadFromTableHover,
  /* Campaigns */
  EditCampaignCIcon,
  EditCampaignCIconBold,
  /* Create-Orders */
  ContactCIcon,
  HtmlIconCIcon,
  ImageRectCIcon,
  MailerCIcon,
  OrderCancelCIcon,
  OrderDetailsCIcon,
  OrderPostcardCIcon,
  OrderSubmitCIcon,
  PlusIconCIcon,
  ReviewOrderCIcon,
  ScheduleOrderCIcon,
  PreviewProofCIcon,
  DownloadProofReviewCIcon,
  /* Order-Details */
  OrderNumberCIcon,
  OrderNameCIcon,
  TemplateNameCIcon,
  TemplateIdCIcon,
  TotalCostCIcon,
  RescheduleCIcon,
  PayAndProcessCIcon,
  CancelCIcon,
  MailerProofCIcon,
  CancelOrderDetailsCIcon,
  ProcessOrderNew,
  /* Dashboard */
  ArrowCIcon,
  DeliveredCIcon,
  EmailCIcon,
  GraphDashboardCIcon,
  InfoCIcon,
  InfoCIconFill,
  ReturnPageCIcon,
  ReturnedCIcon,
  SentCIcon,
  SpendingCIcon,
  TransitCIcon,
  /* General */
  WhiteEditCIcon,
  GeneralInviteCIcon,
  WarningIcon,
  TrashIcon,
  GeneralPencilCIcon,
  GeneralCrossCIcon,
  GeneralArchiveCIcon,
  GeneralRestoreCIcon,
  GeneralArrowBackCIcon,
  GeneralLocationCIcon,
  ArchiveConfirmCIcon,
  CloseModalIcon,
  CloseModalGrey,
  ModalTrashIcon,
  ModeTickCIcon,
  senderAddress,
  senderUser,
  GeneralEditIcon,
  GeneralFormDropdownArrow,
  TableHamburgerIcon,
  XSettingsIcon,
  CheckSettingsIcon,
  /* Header */
  AccountCIcon,
  ChatCIcon,
  DocumentationCIcon,
  DropdownArrrowCIcon,
  HeaderDownArrowCIcon,
  HelpCIcon,
  HelpCenterCIcon,
  Help2CIcon,
  IntegrationCIcon,
  OpenLetterConnectCIcon,
  OpenLetterLogoCIcon,
  SettingsCIcon,
  UserAvatarCIcon,
  LogoutCIcon,
  /* NewDropdown */
  Settings2CIcon,
  UsersCIcon,
  EngagementCIcon,
  BillingCIcon,
  IntegrationsCIcon,
  Logout2CIcon,
  DollarCIcon,
  AdminPortalCIcon,
  GeneralSettingsCIcon,
  DropdownArrowCIcon,
  /* Integrations */
  FramerCIcon,
  HubspotCIcon,
  LoomCIcon,
  SalesforceCIcon,
  SketchCIcon,
  ZapierCIcon,
  /* Login */
  FrameCIcon,
  OpenLetterCIcon,
  SecondaryCIcon,
  OnBoardCIcon,
  GoogleCIcon,
  /* Modal */
  CrossModalCIcon,
  ExportModalCIcon,
  ExportModalSVGCIcon,
  GreenTickCIcon,
  GreenCrossCIcon,
  ImportCancelCIcon,
  ImportSuccessCIcon,
  ModalCrossCIcon,
  RedCrossCIcon,
  VerifyLogoCIcon,
  /* Orders */
  AnalyticsNoDataCIcon,
  AnalyticsCIcon,
  CalenderCIcon,
  CancelIconCIcon,
  CancelOrderCIcon,
  CancelOrderDisabledCIcon,
  DeliverableCIcon,
  DeliveredOrderCIcon,
  DispatchCIcon,
  InsufficientCIcon,
  MailedCIcon,
  NoDataCIcon,
  NoScannedCIcon,
  PaymentCIcon,
  ProcessOrderCIcon,
  ProofCIcon,
  RemoveCIcon,
  RouteCIcon,
  ScannedCIcon,
  SenderCIcon,
  TotalContactCIcon,
  TransitOrderCIcon,
  UndeliverableCIcon,
  CreateOrderCIcon,
  DownloadCIcon,
  DownloadProofCIcon,
  AdminOrderCancelCIcon,
  AdminOrderDispatchCIcon,
  TotalContactsCIcon,
  DeliverableContactsCIcon,
  UndelieverableContactsCIcon,
  TotalDNCCIcon,
  PayAndProcessNewCIcon,
  ExportNewCIcon,
  CancelOrderNewCIcon,
  PlusCIcon,
  ClearFilterCIcon,
  RescheduleActionCIcon,
  PayAndProcessActionCIcon,
  DownloadProofActionCIcon,
  PayAndProcessModalCIcon,
  CancelOrderModalCIcon,
  ModalOrderCrossCIcon,
  NoOrdersScreenCIcon,
  SelectCloseCIcon,
  /* Plans */
  CrossPlansCIcon,
  DowngradeCIcon,
  EnterpriseCIcon,
  GrowthCIcon,
  InfoPlansCIcon,
  ModalClosePlansCIcon,
  NextCIcon,
  PrevCIcon,
  ProfessionalCIcon,
  StaterCIcon,
  UpgradeCIcon,
  /* Settings */
  CopyCIcon,
  DuplicateCIcon,
  DeleteSettingCIcon,
  EditSettingCIcon,
  HideCIcon,
  RotateCIcon,
  ShowCIcon,
  CustomFieldIcon,
  /* Sidebar */
  ApiKeyCIcon,
  ApiLogsCIcon,
  ContactSideBarCIcon,
  ContactSideBarSvgCIcon,
  CustomFieldsCIcon,
  CustomFieldCIcon,
  GeneralCIcon,
  OverviewCIcon,
  OverviewSvgCIcon,
  PlanCIcon,
  ProfileCIcon,
  SidebarHoverCIcon,
  TagsCIcon,
  WalletCIcon,
  WalletSvgCIcon,
  WebhookCIcon,
  ContactImportCIcon,
  ExportLogsCIcon,
  /* User Tables */
  DeleteUserCIcon,
  EditUserCIcon,
  InviteCIcon,
  ResendCIcon,
  WarningCIcon,
  /* Templates */
  TemplateSearchCIcon,
  TemplateSearch2CIcon,
  TemplateDeleteCIcon,
  TemplateCopyCIcon,
  TemplateTrashCIcon,
  TemplateCrossCIcon,
  TemplateAddCIcon,
  TemplateFilterCIcon,
  TemplateSearchOneCIcon,
  TemplatePostcardCIcon,
  TemplatePersonalizedCIcon,
  TemplateProfessionalCIcon,
  TemplateBiFoldCIcon,
  TemplateTrifoldCIcon,
  TemplateRealPennedCIcon,
  TemplateSnapPackCIcon,
  DuplicateTemplateCIcon,
  DownloadTemplateCIcon,
  TrashTemplateCIcon,
  LeftArrowSlideCIcon,
  RightArrowSlideCIcon,
  NoTemplateCIcon,
  TemplateZoomCIcon,
  /* Wallets */
  BalanceCIcon,
  BankCIcon,
  CreditCardFallbackCIcon,
  InfoWalletCIcon,
  MasterCardCIcon,
  PaymentWalletCIcon,
  PaymentTrashCIcon,
  TrashWalletCIcon,
  VisaCIcon,
  WalletPaymentCIcon,
  /* Webhook Details */
  DetailsEditCIcon,
  ForwardCIcon,
  /* Webhooks */
  ArrowRightCIcon,
  BackCIcon,
  CheckmarkCIcon,
  CopyWebhookCIcon,
  CopyIconCIcon,
  DeleteWebhookCIcon,
  DisableCIcon,
  DisabedCIcon,
  EditWebhookCIcon,
  EyeCIcon,
  HideWebhookCIcon,
  InfoWebhookCIcon,
  ShowWebhookCIcon,
  /* Welcome Screen */
  WelcomeCIcon,
  PropertyOffersBackround,
  /* Company */
  CompanyEditBtnIcon,
  CompanyArchiveBtnIcon,
  CompanySearchIcon,
  CompanyImageIcon,
  CompanyUploadIcon,
  CompanyDownloadIcon,
  CompanyTrashIcon,
  BrandingAssetsIcon,
  SenderProfileIcon,
  CopyIcon,
};
